import React, { useRef, useEffect, useState } from "react";
import { Tooltip } from "primereact/tooltip";

interface TruncatedTextProps {
  text: string;
  className?: string;
  tooltipPosition?: "top" | "right" | "bottom" | "left";
  maxWidth?: string;
  tooltipWidth?: string;
  tooltipId?: string;
}

const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  className = "",
  tooltipPosition = "top",
  maxWidth = "max-w-full",
  tooltipWidth = "max-w-md",
  tooltipId = "tooltip",
}) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      const element = elementRef.current;
      if (element) {
        const truncated = element.scrollWidth > element.clientWidth;
        setIsTruncated(truncated);
      }
    };

    checkTruncation();

    // Re-check on window resize
    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [text]);

  // Clean tooltipId to ensure valid CSS selector
  const cleanTooltipId = tooltipId.replace(/[^a-zA-Z0-9-_]/g, "");

  return (
    <>
      <div
        ref={elementRef}
        className={`truncate ${maxWidth} ${className} tooltip-${cleanTooltipId}`}
        data-pr-tooltip={isTruncated ? text : undefined}
        data-pr-position={tooltipPosition}
        style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
      >
        {text}
      </div>
      {isTruncated && (
        <Tooltip
          target={`.tooltip-${cleanTooltipId}`}
          className={`${tooltipWidth}`}
          style={{
            fontSize: "0.875rem",
            padding: "0.5rem 0.75rem",
            color: "#fff",
            borderRadius: "0.375rem",
            zIndex: 9999,
          }}
        />
      )}
    </>
  );
};

export default TruncatedText;
